// extracted by mini-css-extract-plugin
module.exports = {"footer":"_31xbU_g0hq"};